import { _137C, Fury, Blue } from './palette';

export const infoBlockBorderColorError = Fury;
export const infoBlockBorderColorSuccess = Blue;
export const infoBlockBorderColorWarning = _137C;
